import { render, staticRenderFns } from "./SignUpModal.vue?vue&type=template&id=4ae8e390&scoped=true&"
import script from "./SignUpModal.vue?vue&type=script&lang=js&"
export * from "./SignUpModal.vue?vue&type=script&lang=js&"
import style0 from "./SignUpModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SignUpModal.vue?vue&type=style&index=1&id=4ae8e390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae8e390",
  null
  
)

export default component.exports